var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 157,
    viewBox: "0 0 149 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 137,
    height: 138,
    rx: 68.5,
    fill: "#4DD39C",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4430_15258)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 52.5,
    width: 72,
    height: 72,
    rx: 6,
    fill: "white",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.97 37.5011C130.115 37.7571 130.181 38.0503 130.16 38.3439C130.139 38.6374 130.031 38.9181 129.85 39.1505C128.899 40.4176 127.697 41.4748 126.319 42.2563C124.941 43.0377 123.416 43.5265 121.84 43.6921C121.548 43.7273 121.252 43.6754 120.99 43.5428C120.727 43.4102 120.51 43.2029 120.365 42.9471L118.528 39.7063C118.412 39.5019 118.346 39.273 118.335 39.0382C118.325 38.8035 118.37 38.5695 118.467 38.3555C118.564 38.1415 118.71 37.9535 118.894 37.8068C119.077 37.6601 119.293 37.5589 119.523 37.5115C121.921 37.0387 124.101 35.8031 125.738 33.9892C125.897 33.8144 126.095 33.6799 126.316 33.5966C126.536 33.5133 126.774 33.4837 127.008 33.5101C127.243 33.5366 127.468 33.6184 127.665 33.7489C127.861 33.8793 128.024 34.0546 128.14 34.2604L129.97 37.5011Z",
    fill: "#00DBA8",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.325 37.5012C63.4702 37.7572 63.5364 38.0504 63.5152 38.344C63.494 38.6375 63.3863 38.9182 63.2058 39.1506C62.2546 40.4177 61.0523 41.4749 59.6741 42.2563C58.2958 43.0378 56.7712 43.5265 55.1955 43.6921C54.9033 43.7277 54.6072 43.6759 54.3444 43.5433C54.0816 43.4107 53.864 43.2033 53.7189 42.9471L51.8818 39.7064C51.7658 39.5019 51.6998 39.2729 51.6893 39.038C51.6788 38.8032 51.724 38.5692 51.8212 38.3551C51.9184 38.1411 52.0649 37.9531 52.2486 37.8065C52.4324 37.6599 52.6483 37.5588 52.8786 37.5116C55.276 37.0388 57.4561 35.8032 59.0934 33.9893C59.2521 33.816 59.4496 33.6828 59.6696 33.6004C59.8897 33.518 60.1261 33.4889 60.3596 33.5153C60.5931 33.5418 60.817 33.6231 61.0131 33.7526C61.2092 33.882 61.3718 34.0561 61.4878 34.2604L63.325 37.5012Z",
    fill: "#00DBA8",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2864 24.8272C33.9988 24.8892 33.6994 24.8647 33.4258 24.7568C33.1521 24.6489 32.9165 24.4624 32.7487 24.2208C31.8244 22.9339 31.1753 21.4703 30.842 19.9214C30.5087 18.3724 30.4984 16.7713 30.8117 15.2182C30.8641 14.9278 31.0015 14.6595 31.2066 14.4473C31.4116 14.2351 31.675 14.0885 31.9635 14.0262L35.611 13.2499C35.8403 13.2019 36.0776 13.2086 36.3038 13.2695C36.5299 13.3303 36.7386 13.4437 36.9128 13.6003C37.0869 13.7569 37.2217 13.9524 37.3062 14.1708C37.3907 14.3893 37.4225 14.6246 37.399 14.8576C37.1326 17.2864 37.659 19.7362 38.8994 21.8413C39.0173 22.0447 39.0853 22.2732 39.0979 22.508C39.1105 22.7427 39.0674 22.9772 38.9721 23.1921C38.8768 23.407 38.7319 23.5964 38.5494 23.7446C38.3669 23.8928 38.1519 23.9957 37.922 24.045L34.2864 24.8272Z",
    fill: "#FF6196",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1412 32.1401C22.9059 31.9634 22.6235 31.8603 22.3297 31.8439C22.0359 31.8274 21.7438 31.8984 21.4902 32.0477C20.1123 32.8299 18.9104 33.8877 17.9595 35.1552C17.0087 36.4226 16.3293 37.8725 15.9638 39.4143C15.8916 39.6995 15.9054 39.9997 16.0035 40.277C16.1016 40.5544 16.2796 40.7965 16.5151 40.9728L19.4951 43.2078C19.6832 43.3491 19.9021 43.4439 20.1338 43.4844C20.3655 43.5249 20.6036 43.5099 20.8284 43.4408C21.0533 43.3716 21.2586 43.2501 21.4275 43.0864C21.5963 42.9226 21.7241 42.7212 21.8002 42.4986C22.5751 40.1812 24.0789 38.1768 26.0869 36.7844C26.2789 36.649 26.4362 36.4701 26.5459 36.2623C26.6555 36.0546 26.7145 35.8238 26.718 35.5889C26.7215 35.3539 26.6694 35.1215 26.5659 34.9106C26.4624 34.6996 26.3106 34.5161 26.1226 34.3751L23.1412 32.1401Z",
    fill: "#BF8DF2",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9739 25.4084C88.7326 25.5767 88.5465 25.8127 88.4391 26.0866C88.3317 26.3605 88.3078 26.6601 88.3704 26.9475C88.6821 28.5007 89.3107 29.9729 90.217 31.2722C91.1233 32.5714 92.2877 33.6699 93.6376 34.4989C93.8858 34.6572 94.1754 34.7384 94.4697 34.7323C94.7641 34.7262 95.05 34.6331 95.2915 34.4646L98.34 32.3324C98.5328 32.1981 98.6911 32.02 98.802 31.8129C98.9129 31.6057 98.9732 31.3752 98.978 31.1403C98.9828 30.9053 98.9319 30.6726 98.8296 30.461C98.7273 30.2495 98.5764 30.0652 98.3892 29.9231C96.4304 28.4623 94.9967 26.4071 94.3021 24.0644C94.2337 23.8395 94.113 23.6339 93.9499 23.4645C93.7868 23.2952 93.586 23.1668 93.3638 23.09C93.1416 23.0131 92.9044 22.9899 92.6715 23.0222C92.4386 23.0546 92.2167 23.1416 92.0239 23.2762L88.9739 25.4084Z",
    fill: "#4AEFF7",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.375 20.4214C73.4026 20.7144 73.3427 21.0091 73.203 21.2682C73.0632 21.5273 72.8498 21.7392 72.5898 21.8771C71.2027 22.6427 69.6727 23.1141 68.0953 23.2617C66.5178 23.4094 64.9269 23.2302 63.4218 22.7353C63.1405 22.6483 62.8913 22.4798 62.7057 22.2512C62.52 22.0226 62.4063 21.7442 62.3788 21.451L62.0317 17.7424C62.0089 17.5078 62.0422 17.2713 62.1286 17.0521C62.2151 16.8329 62.3522 16.6373 62.5289 16.4814C62.7056 16.3255 62.9168 16.2137 63.145 16.1553C63.3733 16.0968 63.6121 16.0933 63.842 16.1451C66.2226 16.695 68.7171 16.4609 70.9538 15.4776C71.1697 15.3846 71.4046 15.3441 71.6392 15.3593C71.8737 15.3745 72.1014 15.445 72.3035 15.5651C72.5057 15.6851 72.6765 15.8512 72.8022 16.0499C72.9278 16.2486 73.0046 16.4742 73.0264 16.7083L73.375 20.4214Z",
    fill: "#FF8A14",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.288 19.6555C111.065 19.4642 110.904 19.2111 110.824 18.9282C110.745 18.6453 110.751 18.3453 110.841 18.0657C111.302 16.5507 112.07 15.1469 113.097 13.942C114.125 12.7371 115.39 11.7569 116.813 11.0627C117.075 10.9299 117.37 10.8774 117.662 10.9119C117.953 10.9464 118.228 11.0662 118.452 11.2564L121.283 13.6717C121.462 13.8241 121.602 14.0167 121.693 14.2337C121.783 14.4507 121.821 14.6861 121.803 14.9204C121.785 15.1548 121.711 15.3816 121.589 15.5823C121.467 15.783 121.298 15.9518 121.098 16.0751C119.008 17.3412 117.383 19.2488 116.466 21.5136C116.376 21.7309 116.236 21.9238 116.057 22.0767C115.879 22.2296 115.666 22.3379 115.438 22.393C115.209 22.4481 114.971 22.4483 114.742 22.3936C114.513 22.3389 114.301 22.2308 114.122 22.0783L111.288 19.6555Z",
    fill: "#FFF48C",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4985 50.6664C32.7873 50.7207 33.0536 50.8591 33.2639 51.0644C33.4742 51.2696 33.6192 51.5324 33.6805 51.8198C34.0391 53.362 34.0759 54.9615 33.7887 56.5186C33.5016 58.0757 32.8966 59.5569 32.0115 60.8698C31.8511 61.1157 31.6216 61.3088 31.3518 61.4247C31.0821 61.5407 30.784 61.5744 30.4952 61.5215L26.8358 60.8453C26.6046 60.803 26.3867 60.7065 26.1999 60.5638C26.0131 60.4212 25.8627 60.2363 25.761 60.0244C25.6592 59.8125 25.6091 59.5795 25.6147 59.3445C25.6202 59.1095 25.6813 58.8792 25.7929 58.6723C26.9705 56.5311 27.424 54.0663 27.0854 51.6462C27.0545 51.4131 27.0793 51.176 27.1576 50.9543C27.2359 50.7326 27.3655 50.5326 27.536 50.3706C27.7064 50.2086 27.9127 50.0892 28.1381 50.0222C28.3635 49.9553 28.6016 49.9426 28.8328 49.9853L32.4985 50.6664Z",
    fill: "#FFF48C",
    stroke: "#45413C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0715 53.4009V51.9675",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1112 54.6614L18.1244 53.6467",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3702 57.7012H19.8036",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1112 60.7422L18.1244 61.7554",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0715 62.0012V63.4346",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0304 60.7422L10.0172 61.7554",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77139 57.7012H8.33801",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0304 54.6614L10.0172 53.6467",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.877 3.23856V1.80518",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9166 4.49758L99.9298 3.48438",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.176 7.53735H101.609",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9166 10.5784L99.9298 11.5916",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.877 11.8374V13.2708",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.836 10.5784L91.8228 11.5916",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5769 7.53735H90.1435",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.836 4.49758L91.8228 3.48438",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.057 74.7422V73.3103",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135.098 76.0027L136.111 74.9895",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136.357 79.0425H137.791",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.098 82.0835L136.111 83.0967",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M132.057 83.3425V84.7759",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.018 82.0835L128.004 83.0967",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M127.759 79.0425H126.325",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.018 76.0027L128.004 74.9895",
    stroke: "#4ACFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5803 46.2325L85.9323 45.6544C85.6954 45.5714 85.4771 45.4426 85.2899 45.2753C85.1027 45.108 84.9503 44.9054 84.8414 44.6792C84.7325 44.453 84.6693 44.2075 84.6553 43.9568C84.6412 43.7062 84.6767 43.4552 84.7597 43.2182L85.2842 41.7282C85.3672 41.4913 85.4027 41.2403 85.3886 40.9896C85.3746 40.739 85.3114 40.4935 85.2025 40.2673C85.0936 40.0411 84.9412 39.8385 84.754 39.6712C84.5668 39.5038 84.3485 39.375 84.1116 39.2921L82.6216 38.7691C82.3846 38.6861 82.1663 38.5573 81.9791 38.39C81.7919 38.2227 81.6395 38.0201 81.5307 37.7939C81.4218 37.5677 81.3585 37.3222 81.3445 37.0715C81.3305 36.8209 81.3659 36.5699 81.4489 36.3329L81.9734 34.8429C82.0564 34.606 82.0919 34.355 82.0779 34.1043C82.0638 33.8537 82.0006 33.6082 81.8917 33.382C81.7828 33.1558 81.6304 32.9532 81.4432 32.7859C81.256 32.6186 81.0377 32.4897 80.8008 32.4068L79.3108 31.8838C79.0738 31.8009 78.8555 31.672 78.6683 31.5047C78.4812 31.3374 78.3288 31.1348 78.2199 30.9086C78.111 30.6824 78.0477 30.4369 78.0337 30.1863C78.0197 29.9356 78.0552 29.6846 78.1381 29.4477L78.6626 27.9577C78.7456 27.7208 78.7811 27.4699 78.767 27.2194C78.753 26.9688 78.6897 26.7234 78.5808 26.4973C78.4719 26.2712 78.3195 26.0688 78.1323 25.9016C77.9452 25.7344 77.7269 25.6058 77.49 25.523L76 25",
    stroke: "#FFAA54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1999 85.7473L32.4715 86.0006C32.2231 86.0371 31.97 86.0243 31.7265 85.963C31.483 85.9017 31.254 85.793 31.0526 85.6431C30.8511 85.4933 30.6812 85.3052 30.5524 85.0897C30.4236 84.8741 30.3386 84.6353 30.3021 84.3869L30.0726 82.8194C29.9986 82.3183 29.7287 81.8671 29.3222 81.5648C28.9158 81.2625 28.4059 81.1339 27.9047 81.2073L26.3372 81.4367C26.089 81.4732 25.836 81.4605 25.5927 81.3992C25.3495 81.338 25.1206 81.2294 24.9193 81.0797C24.718 80.93 24.5481 80.7421 24.4194 80.5267C24.2907 80.3114 24.2057 80.0728 24.1693 79.8245L23.9398 78.2586C23.9033 78.0101 23.8183 77.7713 23.6895 77.5558C23.5608 77.3403 23.3908 77.1522 23.1893 77.0023C22.9879 76.8525 22.7589 76.7438 22.5154 76.6825C22.2719 76.6211 22.0188 76.6084 21.7704 76.6449L20.2044 76.8758C19.9561 76.9123 19.703 76.8996 19.4596 76.8382C19.2162 76.7768 18.9873 76.6681 18.786 76.5183C18.5847 76.3684 18.4148 76.1803 18.2862 75.9648C18.1576 75.7493 18.0727 75.5105 18.0364 75.2622L17.8055 73.6962C17.7318 73.1964 17.463 72.7461 17.0581 72.444C16.6532 72.1418 16.1451 72.0124 15.645 72.084L14.0715 72.3179",
    stroke: "#FFAA54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M140.656 50.9917L140.187 52.6754C140.119 52.917 140.005 53.1431 139.85 53.3406C139.696 53.5381 139.504 53.7032 139.285 53.8265C139.067 53.9497 138.826 54.0288 138.577 54.0591C138.328 54.0894 138.076 54.0703 137.834 54.003L136.308 53.5783C135.82 53.4424 135.297 53.5061 134.856 53.7553C134.414 54.0046 134.09 54.419 133.954 54.9074L133.529 56.4317C133.462 56.6733 133.348 56.8994 133.193 57.0969C133.038 57.2944 132.846 57.4595 132.628 57.5828C132.409 57.706 132.169 57.7851 131.92 57.8154C131.671 57.8457 131.418 57.8266 131.177 57.7593L129.651 57.3346C129.162 57.1987 128.64 57.2624 128.199 57.5116C127.757 57.7609 127.433 58.1753 127.297 58.6637L126.872 60.188C126.805 60.4297 126.691 60.6559 126.536 60.8535C126.382 61.0511 126.189 61.2163 125.971 61.3396C125.752 61.4629 125.512 61.5419 125.263 61.5721C125.014 61.6023 124.761 61.5831 124.519 61.5156L122.994 61.0909C122.505 60.955 121.983 61.0186 121.541 61.2679C121.1 61.5171 120.775 61.9316 120.639 62.42L120.215 63.9443",
    stroke: "#FFAA54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4430_15258",
    x: 26.3624,
    y: 37.8624,
    width: 115.913,
    height: 115.913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.31878,
    dy: 7.31878
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.9782
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.203922 0 0 0 0 0.533333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_15258"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_15258",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebration);
export default __webpack_public_path__ + "static/media/celebration.a2763bb1abec6d0ea6096782367b7355.svg";
export { ForwardRef as ReactComponent };